// Feature flags for content that is built and preserved in the repo but not
// currently meant to render on the live site. Flip back to `true` to restore.

// Consulting/booking CTAs (Calendly links, "Book a Consultation" buttons, the
// Services nav link/route, the homepage Consulting teaser, etc.) — off while
// a dedicated consulting site is being planned. See also: src/App.tsx and
// src/components/Navigation.tsx, which unlink/unmount the Consulting section
// and /services route independently of this flag.
export const SHOW_CONSULTING = false;
